// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1nSDm","label":"LabeledBox_label__1M9hj"};